<p-checkbox
  [formControl]="formControlInput()"
  [binary]="true"
  [styleClass]="formControlInput().invalid && !formControlInput().untouched ? 'ng-invalid ng-dirty' : ''"
  inputId="conditions"
/>
<label for="conditions" class="ml-2">I agree to Homey's <a class="underline" routerLink="/terms-and-conditions">Terms &
  Conditions</a>
  and
  acknowledge the <a class="underline" routerLink="/privacy-policy">Privacy Policy</a></label>
